// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import TabNavigation from '../../../shared/components/tab-navigation';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {getNavigationTabs} from '../../shared/services/claim-navigation-helper';

const ClaimSearchHeader = (props, context) => {

    const countObject = {
        allClaims: props.allClaimsCount,
        claimSearch: props.claimSearchCount,
        dealerInvoices: props.dealerInvoiceCount
    };

    return (
        <header className='claim-search-header'>
            <TabNavigation tabs={getNavigationTabs(countObject, true, context.user.privacy.showWaitingForDealerInvoice)}/>
        </header>
    );

};

ClaimSearchHeader.displayName = 'ClaimSearchHeader';
ClaimSearchHeader.propTypes = {
    allClaimsCount: PropTypes.number.isRequired,
    claimSearchCount: PropTypes.number.isRequired,
    dealerInvoiceCount: PropTypes.number.isRequired
};
ClaimSearchHeader.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimSearchHeader;



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/claim-search-header.js